import Splide from '@splidejs/splide';

export default class Carousel {
	constructor(wrapper) {

		this.init 					= this.init.bind(this)
		this.progressbar			= wrapper.querySelector('.splide__progress-bar')

		this.carousel = new Splide(wrapper, 
		{
			type: 'slide',
			rewind: false,
			perPage: '3',
			drag: 'free',
			perMove: 'auto',
			autoWidth: true,
			gap: 24,
			padding: 0,
			pagination: false,
			arrows: false,
			breakpoints: {
				600: {
					perPage: '1',
				},
				767: {
					gap: 12,
					perPage: '2',
				},
				1024: {
					gap: 24,
				}
			}
		})

		this.init()

	}

	init() {

		this.progressbar && this.carousel.on( 'mounted move', () => {
			var end  = this.carousel.Components.Controller.getEnd() + 1;
			var rate = Math.min( ( this.carousel.index + 1 ) / end, 1 );
			this.progressbar.style.width = String( 100 * rate ) + '%';
		});

		this.carousel.mount({});

	}
}
